module.exports = {"pagination":{"ListFragments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Fragments"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/kinesis-video-archived-media-2017-09-30.paginators.json
// module id = 1358
// module chunks = 0